// extracted by mini-css-extract-plugin
export default {"TipContainer":"yeVCx06LZuBZPPNGGfcc","TipTitle":"FXEkK7Gz1i9uhK7u1mU6","TipContent":"LwQW6WC1_AiWQoyKHEAN","Tip":"MKtr0WkFxk0J3F9iwlZH"};